import "./vendor";
//import marquee from "vanilla-marquee";
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

Swiper.use([Autoplay]);
const indexSwiper = new Swiper(".indexSwiper", {
    slidesPerView: 6,
    spaceBetween: 30,
    freeMode: true,
    loop: true,
    autoplay: {
        delay: 1500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,

    },
});

/*if(document.getElementById("marquee")) {
	new marquee(document.getElementById("marquee"), {
		speed: 20,
		duplicated: true,
		startVisible: true,
	});
}
if(document.getElementById("marquee-2")) {
	new marquee(document.getElementById("marquee-2"), {
		speed: 20,
		duplicated: true,
		direction: "right",
		startVisible: true,
	});
}*/

document.addEventListener("DOMContentLoaded", function () {
	const accordions = document.querySelectorAll(".accordeon dt");

	accordions.forEach((dt) => {
		dt.nextElementSibling.style.display = "none";

		dt.addEventListener("click", function () {
			const accordeon = this.closest(".accordeon");
			const allDd = accordeon.querySelectorAll("dd");

			allDd.forEach((dd) => {
				if (dd !== this.nextElementSibling) {
					dd.style.display = "none";
					dd.previousElementSibling.classList.remove("active");
				}
			});

			if (this.nextElementSibling.style.display === "none") {
				this.nextElementSibling.style.display = "block";
				this.classList.add("active");
			} else {
				this.nextElementSibling.style.display = "none";
				this.classList.remove("active");
			}
		});
	});
});



